import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors.
        if (error && typeof error === 'object' && 'status' in error) {
          const status = (error as { status: number }).status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
    },
  },
});

/** Query keys — centralised to avoid typos and enable targeted invalidation. */
export const qk = {
  authConfig: ['auth-config'] as const,
  workspace: ['workspace'] as const,
  /** Active org roster (members + invitations); null id means "no active org". */
  org: (organizationId: string | null) => ['org', organizationId] as const,
  groups: ['groups'] as const,
  wahaGroups: ['waha-groups'] as const,
  wahaSessions: ['waha-sessions'] as const,
  wahaSession: (id: string) => ['waha-sessions', id] as const,
  signalAccounts: ['signal-accounts'] as const,
  signalAccount: (id: string) => ['signal-accounts', id] as const,
  signalSharedConfig: ['signal-shared-config'] as const,
  signalGroups: ['signal-groups'] as const,
  slackAccounts: ['slack-accounts'] as const,
  granolaAccounts: ['granola-accounts'] as const,
  granolaMeetings: (accountId: string) => ['granola-meetings', accountId] as const,
  mcpKeys: ['mcp-keys'] as const,
  imports: ['imports'] as const,
  import: (id: string) => ['imports', id] as const,
  sourceAccount: (connector: string, id: string) => ['source-account', connector, id] as const,
  sourceAccountMessages: (connector: string, id: string) =>
    ['source-account-messages', connector, id] as const,
  collection: (id: string) => ['collection', id] as const,
  collectionMessages: (id: string) => ['collection-messages', id] as const,
  destinations: ['destinations'] as const,
  destination: (id: string) => ['destinations', id] as const,
  destinationRuns: (id: string) => ['destination-runs', id] as const,
};
